/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import type { TivoPayloadAction } from '../../../core/tivo/tivo-redux-wrapper';
import { SET_ACCOUNT_OPTIONS_LIST, SET_ACCOUNT_SELECTED_OPTION } from './account.types';
import { IAccountSelectedOption } from './IAccountSelectedOption';

export const setAccountOptionsListAction = (
    optionsList: Array<IAccountSelectedOption>,
): TivoPayloadAction<{
    optionsList: Array<IAccountSelectedOption>;
}> => ({
    type: SET_ACCOUNT_OPTIONS_LIST,
    payload: { optionsList },
});

export const setSelectedAccountOption = (
    selectedOption?: IAccountSelectedOption,
): TivoPayloadAction<{ selectedOption?: IAccountSelectedOption }> => ({
    type: SET_ACCOUNT_SELECTED_OPTION,
    payload: { selectedOption },
});
